import { render, staticRenderFns } from "./globalconnection.vue?vue&type=template&id=66e30d87&scoped=true&"
import script from "./globalconnection.vue?vue&type=script&lang=js&"
export * from "./globalconnection.vue?vue&type=script&lang=js&"
import style0 from "./globalconnection.vue?vue&type=style&index=0&id=66e30d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e30d87",
  null
  
)

export default component.exports